import styled from 'styled-components'

export const ViewElement = styled.div`
  padding-right: 1.8rem;
  padding-left: 1.8rem;
`

export const CartListing = styled(ViewElement)`
  padding-top: 1.8rem;
  margin-bottom: 1.2rem;
`
